import { c as _c } from "react/compiler-runtime";
import { ArrowRightIcon } from "@navikt/aksel-icons";
import { Button, HStack, VStack } from "@navikt/ds-react";
import { knappKlikket } from "@/common/analytics/events-and-properties/knappKlikket-properties";
import type { FetchResultError } from "@/server/tokenXFetch/FetchResult";
import { FetchErrorAlert } from "@/ui/FetchErrorAlert";
import { TrackedButton } from "@/ui/TrackedButton";
interface Props {
  isPendingProceed: boolean;
  isPendingExit: boolean;
  onGoToOppsummeringClick: () => void;
  onAvsluttOgFortsettSenereClick: () => void;
  utkastLagringInfo: React.ReactNode;
  lagreUtkastError: FetchResultError | null;
}
export default function FyllUtPlanButtonsAndSavingInfo(t0) {
  const $ = _c(20);
  const {
    isPendingProceed,
    isPendingExit,
    onGoToOppsummeringClick,
    onAvsluttOgFortsettSenereClick,
    utkastLagringInfo,
    lagreUtkastError
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArrowRightIcon aria-hidden={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isPendingExit || $[2] !== isPendingProceed || $[3] !== onGoToOppsummeringClick) {
    t2 = <HStack gap="space-32"><Button variant="primary" iconPosition="right" icon={t1} onClick={onGoToOppsummeringClick} loading={isPendingProceed} disabled={isPendingExit}>Gå til oppsummering</Button></HStack>;
    $[1] = isPendingExit;
    $[2] = isPendingProceed;
    $[3] = onGoToOppsummeringClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isPendingExit || $[6] !== isPendingProceed || $[7] !== onAvsluttOgFortsettSenereClick) {
    t3 = <TrackedButton variant="tertiary" onClick={onAvsluttOgFortsettSenereClick} loading={isPendingExit} disabled={isPendingProceed} tracking={knappKlikket.nyPlanSide.fyllUtSteg.avsluttOgFortsettSenere}>Avslutt og fortsett senere</TrackedButton>;
    $[5] = isPendingExit;
    $[6] = isPendingProceed;
    $[7] = onAvsluttOgFortsettSenereClick;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3 || $[10] !== utkastLagringInfo) {
    t4 = <HStack gap="space-48" align="center">{t3}{utkastLagringInfo}</HStack>;
    $[9] = t3;
    $[10] = utkastLagringInfo;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== lagreUtkastError) {
    t5 = <FetchErrorAlert error={lagreUtkastError} fallbackMessage={"Vi klarte ikke lagre utkastet ditt. Vennligst pr\xF8v igjen senere."} />;
    $[12] = lagreUtkastError;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <VStack gap="space-16">{t4}{t5}</VStack>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t2 || $[18] !== t6) {
    t7 = <VStack gap="space-32" align="start" className="mt-10">{t2}{t6}</VStack>;
    $[17] = t2;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}